import React, { Component } from "react";
import { SECCIONES_AYUDA_FORM_EVAL_INICIAL } from "./ayudaFormEvalInicial";

class AyudaFormEvalInicialModal extends Component {
  renderSeccion = (sec, idx) => (
    <section key={idx} className="ic-ayudaMenu-seccion">
      <h5>{sec.titulo}</h5>
      {(sec.parrafos || []).map((p, i) => (
        <p key={`p-${i}`}>{p}</p>
      ))}
      {Array.isArray(sec.lista) && sec.lista.length > 0 && (
        <ul>
          {sec.lista.map((item, i) => (
            <li key={`li-${i}`}>{item}</li>
          ))}
        </ul>
      )}
    </section>
  );

  render() {
    const { abierto, onCerrar } = this.props;
    if (!abierto) return null;

    return (
      <div className="ic-modalOverlay" onClick={onCerrar}>
        <div
          className="ic-modalCard ic-modalCard-ayuda ic-modalCard-ayudaMenu"
          onClick={(e) => e.stopPropagation()}
          role="dialog"
          aria-labelledby="ic-ayuda-form-ini-titulo"
        >
          <div className="ic-modalHeader">
            <h4 id="ic-ayuda-form-ini-titulo">
              Ayuda — Formulario Evaluación Inicial
            </h4>
            <button type="button" className="boton" onClick={onCerrar}>
              Cerrar
            </button>
          </div>
          <div className="ic-ayudaMenu-body">
            {SECCIONES_AYUDA_FORM_EVAL_INICIAL.map(this.renderSeccion)}
          </div>
        </div>
      </div>
    );
  }
}

export default AyudaFormEvalInicialModal;
